import {
  BottomNavigationBar,
  CoupangAdBanner,
  Header,
  useConfirm,
} from "@/components";
import styles from "./ReelsContent.module.css";
import { useParams } from "react-router-dom";
import { useEffect, useState, useMemo, useRef } from "react";
import { decoded } from "@/utils";
import { useLoadReset } from "@/hooks";
import Axios from "@/Axios";

const ReelsContent = () => {
  const adMessage =
    "이 포스팅은 쿠팡 파트너스 활동의 일환으로, 이에 따른 일정액의 수수료를 제공받습니다.";
  const confirm = useConfirm();
  const iframeRef = useRef(null);
  const loadReset = useLoadReset();
  const defaultState = {
    id: "",
    reelsNm: "",
    image: "",
    link: "",
    caption: "",
    hasError: false,
    onLoaded: false,
  };
  const [state, setState] = useState(defaultState);
  const { info } = useParams();
  const resetState = () => {
    setState(() => ({ ...defaultState }));
    loadReset();
  };
  const adKey = useMemo(() => new Date().getTime(), []);
  const setHasError = (flag) => {
    setState((s) => ({ ...s, hasError: flag, onLoaded: !flag }));
  };

  const getContents = (id) => {
    Axios.get("/api/reels/contents", { params: { reelsId: id } }).then(
      (res) => {
        if (res.data?.errMsg) {
          confirm(`${res.data.errMsg}\n(${res.data.errCode})`);
          return;
        }
        setState((s) => ({ ...s, ...res.data.reels }));
      }
    );
  };

  useEffect(() => {
    const data = decoded(info, true);
    getContents(data.id);
    setState((s) => ({
      ...s,
      id: data.id,
      mediaId: data.mediaId,
      reelsNm: data.reelsNm,
    }));
    return resetState;
  }, []);
  return (
    <div className={styles.contentContainer}>
      <Header title={state.reelsNm} />
      <div className={styles.iframeContainer}>
        {state.link && !state.hasError ? (
          <video
            ref={iframeRef}
            className={styles.iframe}
            poster={state.image}
            controls
          >
            <source
              src={state.link}
              type="video/mp4"
              onError={() => {
                setHasError(true);
              }}
            />
            브라우저가 video 태그를 지원하지 않습니다
          </video>
        ) : (
          <div className={styles.notFoundContainer}>
            <pre
              className={styles.notFound}
            >{`릴스가 존재하지 않습니다\nid: ${state.mediaId}`}</pre>
          </div>
        )}
      </div>
      <pre className={styles.caption}>{state.caption}</pre>
      <div className={styles.adBannerWrapper}>
        <div className={styles.adBanner}>
          <div className={styles.adBannerContents}>
            <CoupangAdBanner key={adKey} />
          </div>
        </div>
        <div className={styles.AdMessage}>{adMessage}</div>
      </div>
      <BottomNavigationBar />
    </div>
  );
};

export default ReelsContent;
